var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.491,
    height: 22,
    viewBox: "0 0 16.491 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041E\\u0413\\u041A_\\u0413\\u0440\\u0443\\u043F\\u043F-36",
    "data-name": "\\u041E\\u0413\\u041A \\u0413\\u0440\\u0443\\u043F\\u043F-36",
    transform: "translate(0 0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M296.245,393.972a.688.688,0,0,1-.55-.275l-5.923-8.355-.215-.3a8.245,8.245,0,1,1,13.375,0l-.288.4-5.85,8.245a.687.687,0,0,1-.55.289Zm0-16.49a2.748,2.748,0,1,0,2.748,2.748A2.748,2.748,0,0,0,296.245,377.481Z",
    transform: "translate(-288 -372)",
    fill: "#1f1f1f",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLocation);
export default __webpack_public_path__ + "static/media/black-location.78d1f59a445671402ccae0c85de014ca.svg";
export { ForwardRef as ReactComponent };